export default {
  goose3_duck3: '青萍温湿度计 / Lite',
  gd3_title: '青萍温湿度计 / Lite',
  gd3_first_title: '精准测温湿',
  gd3_screen: '显示屏',
  gd3_range: '量程',
  gd3_e_ink: '电子墨水屏',
  gd3_segment_lcd: '段码液晶屏',
  gd3_temp_label: '温度：',
  gd3_humi_label: '湿度：',
  gd3_screen_label: '屏幕',
  gd3_goose_screen: '电子墨水屏，50 × 50 毫米',
  gd3_duck_screen: '段码液晶屏，50 × 50 毫米',
  gd3_five_desc:
    '搭配米家蓝牙网关设备，可设置青萍温湿度计和青萍温湿度计 Lite 与米家智能设备的联动，改善{br}室内温湿度环境，让家更舒适。',
}
